import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
// style
import s from '../viewBooking/ViewBooking.css';
// graphql
import viewRideBookingDetailsQuery from './viewRideBookingDetails.graphql';
// components
import ViewRideBookingDetails from '../../../components/SiteAdmin/Booking/ViewRideBookingDetails';
import Loader from '../../../components/Common/Loader/Loader';

export class ViewRideBooking extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired
    };

    static defaultProps = {
        data: {
            loading: true
        },
        listSearch: ''
    };

    render() {
        const { data: { loading, viewRideBookingDetails, refetch }, title, listSearch } = this.props;

        return (
            <Loader type={"page"} show={loading}>
                <div className={s.paddingRoutesSection}>
                    {
                        !loading && <ViewRideBookingDetails
                            data={viewRideBookingDetails}
                            title={title}
                            listSearch={listSearch}
                            refetch={refetch}
                        />
                    }
                </div>
            </Loader>
        )
    }
}

export default compose(
    withStyles(s),
    graphql(viewRideBookingDetailsQuery, {
        options: (props) => ({
            variables: {
                id: props.id
            },
            fetchPolicy: 'network-only',
        })
    })
)(ViewRideBooking);
